<template>
    <div>
        <skupovi-navigation
            :id="skup_id"
            :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Suorganizator: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <skup-suorganizator-forma
                    :disabled="false"
                    :id="id"
                    :modal="false"
                    :action="'edit'"
                    @returnData="setData"
                >
                </skup-suorganizator-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupoviNavigation from "../SkupNavigation";
import SkupSuorganizatorForma from "./SkupSuorganizatorForma";
export default {
    name: "SkupSuorganizatorEdit",
    components: { SkupSuorganizatorForma, SkupoviNavigation },
    data(){
        return {
            breadcrumbs: [],
            id:this.$route.params.skup_suorganizator_id,
            skup_id: this.$route.params.skup_id,
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/suorganizatori',
                    name: 'Suorganizatori'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/suorganizatori/' + this.id,
                    name: 'Suorganizator: ' + this.naziv
                },
                {
                    path: '/skupovi/' + this.skup_id + '/suorganizatori/' + this.id + '/edit',
                    name: 'Uredi suorganizatora: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.suorganizator.naziv
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
